<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>服务者列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="加盟商" label-width="90px">
                    <el-select placeholder="请选择" clearable filterable v-model="listQuery.fraId" width="100px">
                        <el-option v-for="item in franchiseeList" :key="item.id" :label="item.fraName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="城市" label-width="90px">
                    <el-select v-model="listQuery.cityId" clearable style="width:150px" placeholder="请选择城市" filterable
                        >
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="区域" label-width="90px">
                    <el-select v-model="listQuery.areaIds" clearable style="width:150px" placeholder="请选择区域" filterable multiple>
                        <el-option v-for="(item, index) in areaList" :key="index" :label="item.areaName" :value="item.id "></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="驿站" label-width="90px">
                    <el-select v-model="listQuery.postStationId" style="width:150px" clearable placeholder="请选择驿站"
                        filterable>
                        <template v-for="(item, index) in postStationList">
                            <el-option :key="index" v-if="item.cityId == listQuery.cityId" :label="item.postStationName"
                                :value="item.id + ''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="服务站" label-width="90px">
                    <el-select v-model="listQuery.stationId" style="width:150px" clearable placeholder="请选择服务站"
                        filterable>
                        <template v-for="(item, index) in allStationList">
                            <el-option :key="index" v-if="item.cityId == listQuery.cityId"
                                :label="item.stationName" :value="item.id + ''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="服务者类型">
          <el-select v-model="listQuery.workerType" clearable placeholder="请选择服务类型" filterable>
            <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
                <el-form-item label="服务者Id" label-width="90px">
                    <el-input v-model="listQuery.id" type="number" maxlength="11" style="width:150px"
                        placeholder="请输入服务者Id" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务者编号" label-width="90px">
                    <el-input v-model="listQuery.workerNo" maxlength="11" style="width:150px" placeholder="请输入服务者编号"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="服务者姓名" label-width="90px">
                    <el-input v-model="listQuery.workerName" maxlength="11" style="width:150px" placeholder="请输入服务者姓名"
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="服务者电话" label-width="90px">
                    <el-input v-model="listQuery.workerTel" maxlength="11" style="width:150px" placeholder="请输入服务者电话"
                        clearable></el-input>
                </el-form-item>

                <!-- <el-form-item label="标签" label-width="90px">
                    <el-select v-model="listQuery.label" style="width:150px" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in labelList" :key="index" :label="item.labelName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item label="服务者归属" label-width="90px">
                    <el-select v-model="listQuery.workerBelongId" style="width:150px" clearable placeholder="请选择服务者归属"
                        filterable>
                        <!-- <el-option v-for="(item,index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option> -->
                        <template v-for="(item, index) in supplierList">
                            <el-option v-if="item.sourceType == 1" :key="index" :label="item.name"
                                :value="item.id"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

              <el-form-item label="服务者来源" label-width="90px">
                <el-select v-model="listQuery.sourceRelationId" style="width:150px" clearable placeholder="请选择服务者归属"
                           filterable>
                  <!-- <el-option v-for="(item,index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option> -->
                  <template v-for="(item, index) in supplierList">
                    <el-option v-if="item.sourceType == 1" :key="index" :label="item.name"
                               :value="item.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>

                <el-form-item label="服务者状态" label-width="90px">
                    <el-select v-model="listQuery.state" clearable style="width:150px" placeholder="服务者状态" filterable>
                        <el-option v-for="(item, index) in workerState" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核状态" label-width="90px">
                    <el-select v-model="listQuery.approveState" style="width:150px" clearable placeholder="审核状态"
                        filterable>
                        <el-option v-for="(item, index) in approveState" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="签约状态" label-width="90px">
                    <el-select v-model="listQuery.signContractState" style="width:150px" clearable placeholder="合同签署状态"
                        filterable>
                        <el-option v-for="(item, index) in signContractStateArr" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="健康证状态" label-width="90px">
                    <el-select v-model="listQuery.healthCertificate" style="width:150px" clearable placeholder="健康证状态"
                        filterable>
                        <el-option v-for="(item, index) in healthCertificateState" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务渠道" label-width="90px">
                    <el-select v-model="listQuery.serviceChannel" style="width:150px" clearable placeholder="服务渠道"
                        filterable>
                        <el-option v-for="(item, index) in serviceChannels" :key="index" :label="item"
                            :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="上线时间" label-width="90px">
                    <el-date-picker v-model="onlineTimeArr" value-format="yyyy-MM-dd" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="解约时间" label-width="90px">
                    <el-date-picker v-model="lossTimeArr" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="商家运营" label-width="90px">
                    <el-select v-model="listQuery.workerManagerId" style="width:150px" clearable placeholder="商家运营"
                        filterable>
                        <el-option v-for="(item, index) in workerManager" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="驿站老师" label-width="90px">
                    <el-select v-model="listQuery.workerPostLeaderId" style="width:150px" clearable placeholder="驿站老师"
                        filterable>
                        <el-option v-for="(item, index) in workerPostLeader" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="服务者标签" label-width="90px">
                  <el-select v-model="listQuery.tags" style="width:150px" multiple clearable placeholder="请选择"
                            filterable>
                       <el-option v-for="(item, idx) in commutilData.tagsList" :key="idx" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <el-button v-per="'exportWorker'" icon="el-icon-download" type="primary" plan
                        @click="downWorker()">导出</el-button>
                   <!-- <el-button v-per="'addMeiTuanServant'"  icon="el-icon-edit"  type="primary" plan @click="handleCreateMT">添加盒马人员</el-button> -->
                    <!-- <el-button v-per="'exportWorkerNY'" icon="el-icon-download" type="primary" plan
                        @click="downWorkerNewYear()">导出春节档</el-button> -->
                </el-form-item>
                <!-- 测试背调-->
                <el-form-item v-per="'beidiaoTest'" >
                    <el-button icon="el-icon-search" type="primary" plan
                        @click="openBeidiaoTest">临时背调</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column v-if="listQuery.userId == 1" prop="id" label="服务者Id" width="100"></el-table-column>
                <!-- <el-table-column prop="workerBelongName" label="加盟商"></el-table-column> -->
                <el-table-column prop="workerNo" label="服务者基本信息" width="160">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者编号:</span> {{ scope.row.workerNo }}<br />
                            <span style="font-weight: 600;">服务者名称:</span> {{ scope.row.workerName }}<br />
                            <span style="font-weight: 600;">加盟商:</span> {{ scope.row.workerBelongName }}<br />
                            <span style="font-weight: 600;">服务渠道:</span> <el-tag
                                :type="scope.row.serviceChannel in serviceChannels ? '' : 'warning'"> {{
                scope.row.serviceChannel in serviceChannels ? serviceChannels[scope.row.serviceChannel]
                    : '未设置'
            }}</el-tag><br />
                            <span style="font-weight: 600;">信息是否完善:</span> <el-tag
                                :type="scope.row.ocrState == 1 ? 'success' : 'info'">{{ scope.row.ocrState == 1 ? '已完善'
                : '未完善' }}</el-tag><br />
                          <span style="font-weight: 600;">服务者标签:</span> {{ scope.row.tag  }}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerNo" label="服务者其他信息" width="230">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者性别:</span> {{ scope.row.gender }}<br />
                            <span style="font-weight: 600;">服务者籍贯:</span> {{ scope.row.nativePlace }}<br />
                            <span style="font-weight: 600;">服务者身份证:</span> {{ scope.row.workerIdcard }}<br />
                            <span style="font-weight: 600;">服务者电话:</span> <phoneTag :phone="scope.row.workerTel" /><br />
                             <span style="font-weight: 600;">紧急联系人:</span> {{ scope.row.emergencyContact }},{{ scope.row.emergencyTel }}<br />

                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="服务者城市信息" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">城市:</span> {{ scope.row.cityName }}<br />
                            <!-- <span style="font-weight: 600;">驿站:</span> {{ scope.row.cityDto.postStationName }}<br />
                            <span style="font-weight: 600;">驿站老师:</span> {{ scope.row.workerPostLeader }}<br /> -->
                            <span style="font-weight: 600;">服务站:</span> {{ scope.row.cityDto.stationName }}<br />
                            <span style="font-weight: 600;">综合星级:</span> {{ scope.row.scoreLevel }}<br />
                            <!-- <span style="font-weight: 600;">商家运营:</span> {{ scope.row.workerManager }}<br /> -->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="cityDto.postStationName" label="驿站"></el-table-column>
                <el-table-column prop="cityDto.stationName" label="服务站"></el-table-column>
                <el-table-column prop="gender" width="60" label="性别"></el-table-column>
                <el-table-column prop="nativePlace" width="80" label="籍贯"></el-table-column>
                <el-table-column prop="workerIdcard" width="150" label="服务者身份证"></el-table-column>
                <el-table-column prop="workerTel" width="100" label="服务者电话">
                    <template slot-scope="scope">
                        <phoneTag :phone="scope.row.workerTel" />
                    </template>
                </el-table-column>-->
                <!-- <el-table-column prop="labelNames" width="150" label="服务者标签"></el-table-column>

                <el-table-column prop="state" width="100" label="服务者状态">
                    <template slot-scope="scope">
                          <el-tag :type="scope.row.state == 2 ? 'success' : 'warning'">{{ workerState[scope.row.state]
                            }}<br />{{ workerSubState[scope.row.subState] }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceChannel" label="服务渠道">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.serviceChannel in serviceChannels ? '' : 'warning'"> {{
                scope.row.serviceChannel in serviceChannels ? serviceChannels[scope.row.serviceChannel] : '未设置'
            }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="workerManager" label="商家运营"></el-table-column>-->
                <el-table-column prop="workerName" label="服务者证件状态" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">新农保上传状态:</span> {{ scope.row.newFarmerStatus }}<br />
                            <span style="font-weight: 600;">签约结果:</span> <el-tag
                                :type="scope.row.signContractState == 1 ? 'success' : 'warning'">{{
                scope.row.signContractState == 1 ? '已签约' : '未签约' }}</el-tag><br />
                            <span style="font-weight: 600;">健康证上传结果:</span> <el-tag
                                :type="scope.row.healthCertificate == 1 ? 'success' : 'warning'">{{
                healthCertificateState[scope.row.healthCertificate] }}</el-tag><br />
                            <span style="font-weight: 600;">是否复职:</span> {{ scope.row.reinstated == '1' ? '是' : '否'
                            }}<br />

                          <span style="font-weight: 600;">是否上传花王认证证书:</span> {{ scope.row.isHwAuth == '1' ? '是' : '否'
                          }}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="服务者状态信息" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者状态:</span> <el-tag
                                :type="scope.row.state == 2 ? 'success' : 'warning'">{{ workerState[scope.row.state]
                                }}<br />{{ workerSubState[scope.row.subState] }}</el-tag><br />
                            <span style="font-weight: 600;">上线审批状态:</span> {{ approveState[scope.row.approveState]
                            }}<br />
                            <span style="font-weight: 600;">上线时间:</span> {{ scope.row.onlineTime  | dateFormatA}}<br />
                            <span style="font-weight: 600;">解约时间:</span> {{ scope.row.leaveTime  | dateFormatA}}<br />
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="newFarmerStatus" label="新农保上传状态"></el-table-column>
                <el-table-column prop="approveState" label="上线审批状态">
                    <template slot-scope="scope">
                        {{ approveState[scope.row.approveState] }}
                    </template>
                </el-table-column>

                <el-table-column prop="onlineTime" label="上线时间" :formatter="dateFormatA"></el-table-column>
                <el-table-column prop="leaveTime" label="解约时间" :formatter="dateFormatA"></el-table-column>
                <el-table-column prop="reinstated" label="是否复职">
                    <template slot-scope="scope">
                        {{ scope.row.reinstated == '1' ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="meetZzy" label="招招盈资格">
                    <template slot-scope="scope">
                        {{ scope.row.meetZzy == '1' ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="pauseZzy" label="是否暂停招招盈">
                    <template slot-scope="scope">
                        {{ scope.row.pauseZzy == '1' ? '是' : (scope.row.pauseZzy == '0' ? '否' : '') }}
                    </template>
                </el-table-column>

                <el-table-column prop="ocrState" label="信息是否完善">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ocrState == 1 ? 'success' : 'info'">{{ scope.row.ocrState == 1 ? '已完善'
                : '未完善' }}</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column prop="workerName" label="招招盈" width="150">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">招招盈资格:</span> {{ scope.row.meetZzy == '1' ? '是' : '否'
                            }}<br />
                            <span style="font-weight: 600;">是否暂停招招盈:</span> {{ scope.row.pauseZzy == '1' ? '是' :
                (scope.row.pauseZzy == '0' ? '否' : '') }}<br />
                        </div>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="signContractState" label="签约结果">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.signContractState == 1 ? 'success' : 'warning'">{{
                scope.row.signContractState == 1 ? '已签约' : '未签约' }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="healthCertificate" label="健康证上传结果">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.healthCertificate == 1 ? 'success' : 'warning'">{{
                healthCertificateState[scope.row.healthCertificate] }}</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column prop="workerName" label="其他">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">业务线:</span> <el-tag>{{ scope.row.buzLine | filterWorkerType
                                }}</el-tag><br />
                            <span style="font-weight: 600;">服务者归属:</span> {{ scope.row.workerBelongName }}<br />
                            <span style="font-weight: 600;">服务者休息日:</span> {{ scope.row.restDay }}<br />
                            <span style="font-weight: 600;">创建时间:</span> {{ scope.row.createTime | dateFormatA }}<br />
                        </div>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="buzLine" label="业务线">
                    <template slot-scope="scope">
                        <el-tag>{{ scope.row.buzLine | filterWorkerType }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="workerBelongName" label="服务者归属"></el-table-column>
                <el-table-column prop="sourceRelationName" label="来源"></el-table-column>

                <el-table-column prop="restDay" label="休息日"></el-table-column>

                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column> -->
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
                        <!-- <el-button type="text" v-if="scope.row.workerBelongId==globalData.userInfo.id&&scope.row.state!=2" icon="el-icon-info" @click="handleJoin(scope.row)">上线</el-button> -->
                        <el-button type="text" v-per="'ruzhi'"
                            v-show="scope.row.state == 1 && scope.row.approveState == 0" icon="el-icon-info"
                            @click="handleJoin(scope.row)">上线</el-button>
                        <el-button type="text" v-per="'ruzhi'"
                            v-show="scope.row.state == 5 && scope.row.approveState == 3" icon="el-icon-info"
                            @click="handleJoin(scope.row)">再次申请上线</el-button>

                        <el-button type="text" v-per="'shenpi'"
                            v-show="scope.row.state == 1 && scope.row.approveState == 1" icon="el-icon-info"
                            @click="toSp(scope.row)">审批</el-button>
                        <el-button type="text" v-per="'liushi'" v-show="scope.row.state == 1" icon="el-icon-info"
                            @click="handleLoss(scope.row, 2, 5)">流失</el-button>
                        <el-button type="text" v-per="'lizhi'" v-show="scope.row.state == 2" icon="el-icon-info"
                            @click="goResign(scope.row.workerNo)">解约</el-button>
                        <el-button type="text" v-per="'fuzhi'" v-show="scope.row.state == 3" icon="el-icon-info"
                            @click="reinstated(scope.row)">复职</el-button>
                        <el-button type="text"
                            v-show="(scope.row.state == 1 || scope.row.state == 2) && scope.row.meetZzy == 0"
                            icon="el-icon-document-checked" @click="setZzy(scope.row, 1)"
                            v-per="'zzyzg'">设置招招盈资格</el-button>
                        <el-button type="text"
                            v-show="(scope.row.state == 1 || scope.row.state == 2) && scope.row.meetZzy == 1"
                            icon="el-icon-document-delete" @click="setZzy(scope.row, 0)"
                            v-per="'zzyzg'">取消招招盈资格</el-button>
                        <el-button type="text"
                            v-show="(scope.row.state == 1 || scope.row.state == 2) && scope.row.meetZzy == 1 && scope.row.pauseZzy != 1"
                            icon="el-icon-video-pause" @click="pauseZzy(scope.row, 1)"
                            v-per="'zzyzg'">暂停招招盈资格</el-button>
                        <el-button type="text"
                            v-show="(scope.row.state == 1 || scope.row.state == 2) && scope.row.meetZzy == 1 && scope.row.pauseZzy === 1"
                            icon="el-icon-video-play" @click="pauseZzy(scope.row, 0)"
                            v-per="'zzyzg'">取消暂停招招盈</el-button>

                        <el-button type="text" v-show="checkSignState(scope.row)"
                            @click="clickSign(scope.row)">签署合作协议</el-button>
                        <el-button type="text" @click="clickBackInvestigation(scope.row)"
                            v-show="scope.row.signPersonState == 1 && scope.row.backInvestigate == false && scope.row.backInvestigateInfo == ''">背调发起</el-button>
                            <el-button type="text"
                            v-show=" scope.row.signContractState == 1"  icon="el-icon-info" @click="restHZXY(scope.row)" >合作协议重签</el-button>

<!--                        <el-button type="text" icon="el-icon-map-location"-->
<!--                            @click="handleArea(scope.row)">接单区域</el-button>-->
                        <!-- v-if="scope.row.signPersonState==1&&scope.row.backInvestigate==false&&scope.row.backInvestigateInfo==''" -->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- <el-dialog title="服务者背调" :visible.sync="showBIVisible" width="900px" :close-on-click-modal="false" center> -->
        <addServantDia ref="addServantDiaRef" />
        <!-- </el-dialog> -->

        <!--合同签署 -->
        <!-- <signContractDia ref="signContractDiaRef" /> -->

        <!--上线审批 -->
        <joinEmploymentApproval ref="joinEmploymentApprovalRef" />

        <!--线索流失 -->
        <leaveLossForm ref="leaveLossFormRef" />
        <!--接单区域 -->
        <workerAreaForm ref="workerAreaFormRef" />

        <!-- 合同解除 -->
        <resign @querySearch="querySearch" ref="resign" />
        <!--保洁服务合作协议-->
        <signBaodi ref="signBaodi" />

                <!--美团人员录入，简化录入-->
                <addMeiTuanServant ref="addMeiTuanServant" />

                <!--测试背调-->
                <el-dialog title="测试背调" :visible.sync="beidiaoVisible" width="500px" :close-on-click-modal="false" center>
                    <!--背调结果-->
                    <div v-if="beidiaoResult" style="margin-bottom:15px;">
                        <el-alert :title="beidiaoResult.success ? '背调验证成功' : '背调验证失败'"
                            :type="beidiaoResult.success ? 'success' : 'error'" :closable="false" show-icon>
                        </el-alert>
                        <pre
                            style="max-height:200px;overflow:auto;background:#f5f7fa;border:1px solid #ebeef5;border-radius:4px;padding:10px;margin:10px 0 0;font-size:12px;white-space:pre-wrap;word-break:break-all;">{{ beidiaoResult.detail }}</pre>
                    </div>
                    <el-form :model="beidiaoForm" label-width="80px" size="small">
                        <el-form-item label="姓名">
                            <el-input v-model="beidiaoForm.name" placeholder="请输入姓名" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="身份证">
                            <el-input v-model="beidiaoForm.idcard" placeholder="请输入身份证" clearable></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer">
                        <el-button @click="beidiaoVisible = false">关 闭</el-button>
                        <el-button type="primary" :loading="beidiaoLoading" @click="handleBeidiaoTest">背调验证</el-button>
                    </div>
                </el-dialog>
    </div>
</template>
<script>
import url from "@/script/baseUrl.js";
import Pagination from "@/components/common/Pagination";
import commutilData from "@/components/common/commutil.data";
import wmsApi from "@/script/api/wmsApi";
import contractApi from "@/script/api/contractapi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import addServantDia from "@/components/workercrm/addServantDia.vue";
import signContractDia from "@/components/workercrm/compent/signContract.vue";
import joinEmploymentApproval from "@/components/workercrm/compent/joinEmploymentApproval.vue";
import leaveLossForm from "@/components/workercrm/compent/leaveLossForm.vue";
import workerAreaForm from "@/components/workercrm/compent/workerAreaForm.vue";
import globalData from "@/components/common/globaldata/global.data.vue";
import phoneTag from "@/components/workercrm/compent/phoneTag.vue";
import signBaodi from "@/components/workercrm/contract/compent/signBaodi";
import moment from "moment";
import resign from "@/components/workercrm/contract/compent/resign";
import addMeiTuanServant from "@/components/workercrm/compent/addMeiTuanServant";

let vm;
export default {
    components: {
        Pagination,
        addServantDia,
        signContractDia,
        joinEmploymentApproval,
        leaveLossForm,
        workerAreaForm,
        phoneTag,
        signBaodi,
        resign,
        addMeiTuanServant
    },
    filters: {
        filterWorkerType(type) {
            if (type == 1) return "保洁";
            if (type == 2) return "保姆";
            if (type == 3) return "品类";
        },
        dateFormatA(date) {
            if (date == undefined || date == "") {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm");
        }
    },
    data() {
        return {
            signContractStateArr: {
                1: "已签约",
                0: "未签约"
            },
            healthCertificateState: {
                0: "未上传",
                1: "已上传",
                2: "健康证即将到期",
                3: "健康证已到期",
            },
            approveState: {
                1: "待审批",
                2: "审批通过",
                3: "未通过",
            },
            serviceChannels: {
                1: "盒马",
                2: "私域",
                3: "公用",
                4: "美团"
            },
            workerState: {
                1: "待上线",
                2: "已上线",
                3: "已解约",
                // 4: "复职",
                5: "上线失败",
            },
            workerSubState: {
                1: '背调失败', 2: '培训淘汰', 3: '拒绝上线', 4: '上线审批拒绝'
            },
            workerManager: [],
            tempRow: {},
            commutilData: commutilData,
            workTypes: commutilData.serviceModelList,
            supplierList: [],
            listData: [],
            cityList: [],
            areaList: [],
            postStationList: [],
            allStationList: [],
            workerPostLeader: [],
            sysUserList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                id: '',
                selectType: 1,
                cityId: null,
                postStationId: null,
                stationId: null,
                workerNo: null,
                workerName: null,
                label: null,
                signContractState: null,
                healthCertificate: null,
                userId: globalData.userInfo.id,
                approveState: '',
                areaIds: [],
                fraId: null,
                tags: [],

            },
            onlineTimeArr: [],
            lossTimeArr: [],
            showBIVisible: false,
            labelList: [],
            franchiseeList: [],
            //测试背调
            beidiaoVisible: false,
            beidiaoLoading: false,
            beidiaoResult: null,
            beidiaoForm: {
                name: '',
                idcard: ''
            },
        };
    },

    created() {
        this.getAllCity();
        // this.getAllPostStation();
        this.getAllStationList();
        this.getSupplierList();
        this.getAllSkill();
        this.getWorkerManager();
        this.getWorkerPostLeader();
        this.getAllJms();

    },

    mounted(){
      if(this.$route.query.wokrerNo){
        this.listQuery.workerNo = this.$route.query.wokrerNo;
      }
      this.querySearch();
    },

    methods: {
      handleCreateMT() {
            let date = moment(new Date()).format("YYYY-MM-DD HH:ss:mm");
            this.$refs.addMeiTuanServant.addServantData(
                '',
                '',
                '',
                // step,
                date,
            );
        },
      restHZXY(row){
        this.$confirm(`是否确认重签（保洁服务合作协议）?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(() => {
                  workercrmapi.$ajaxResetSignContract({workerNo:row.workerNo}).then(res => {
                          if (res.data.errno == 0) {
                              this.$message.success('操作成功');
                              this.querySearch();
                          } else {
                            this.$message.error(res.data.data);
                          }
                      })
              })
              .catch(() => { });
      },
        getAllJms() {
            workercrmapi.$ajaxgetAllJms().then(res => {
                this.franchiseeList = res.data.data;
            })
        },
        getAllPostStation() {
            //驿站
            workercrmapi
                .$axiosPostStationgetAllList({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.postStationList = res.data.data;
                    }
                });
        },
        getAllStationList() {
            //服务站
            wmsApi
                .$axiosGetAllStationList({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allStationList = res.data.data;
                    }
                });
        },
        checkSignState(row) {
            //签署合同按钮判断
            if (
                row.state == 1 &&
                row.backInvestigate == true &&
                row.signContractState == 0
            ) {
                return true;
            }
            return false;
        },
        getAllSkill() {
            workercrmapi.$axiosEmLableSkillGetAllLabelSkill().then((res) => {
                if (res.data.errno == 0) {
                    this.labelList = res.data.data;
                }
            });
        },
        setZzy(row, type) {
            let str = (type == 1 ? '设置' : '取消')
            this.$confirm(`是否确认${str}招招盈资格?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    service.$axioSetZzy({
                        workerId: row.id,
                        isZzy: type,
                        operId: globalData.userInfo.id,
                        operName: globalData.userInfo.userName,
                    })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success('操作成功');
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        pauseZzy(row, type) {
            let str = (type == 1 ? '暂停' : '取消暂停')
            this.$confirm(`是否确认${str}招招盈资格?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    service.$axioPauseZzy({
                        workerId: row.id,
                        pauseZzy: type,
                        operId: globalData.userInfo.id,
                        operName: globalData.userInfo.userName,
                    })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success('操作成功');
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        reinstated(row) {
            //复职
            this.$confirm("是否确认复职?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    workercrmapi
                        .$axiosleaveOrLossOrReinstated({
                            workerNo: row.workerNo,
                            operType: 4,
                            // parseObject: this.refuseOnlineForm.levelOne,
                            operUserId: globalData.userInfo.id,
                            operUserName: globalData.userInfo.userName,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success('操作成功');
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        handleLoss(row, type, subType) {
            //流失或解约
            //subType解约时，子类型1线索流失，2上线失败，3跟单失败，4培训失败
            this.$refs.leaveLossFormRef.leaveLossClick(row, type, subType);
        },
        handleArea(row) {

            this.$refs.workerAreaFormRef.init(row);
        },
        toSp(row) {
            this.$refs.joinEmploymentApprovalRef.toSp(row);
        },
        clickSign(row) {
            // this.$refs.signContractDiaRef.clickSign(row);
            //签约 未来区分保姆或保洁合同
            this.$refs.signBaodi.showDetail(row.workerNo);
        },
        clickBackInvestigation(row) {
            this.$confirm("是否确定发起背调?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    workercrmapi.$axiosWorkerInvestigation({
                        workerSupplierId: row.id,
                        operatorId: globalData.userInfo.id,
                        operatorName: globalData.userInfo.userName
                    })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("背调成功");
                                //    this.$message.success(res.data.data.data.respDesc);
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });

        },
        //测试背调
        openBeidiaoTest() {
            this.beidiaoForm = {
                name: '',
                idcard: ''
            };
            this.beidiaoResult = null;
            this.beidiaoVisible = true;
        },
        //将背调返回结果格式化为文本
        formatBeidiaoResult(data) {
            if (data === null || data === undefined || data === '') {
                return '无返回数据';
            }
            if (typeof data === 'object') {
                try {
                    return JSON.stringify(data, null, 2);
                } catch (e) {
                    return String(data);
                }
            }
            return String(data);
        },
        handleBeidiaoTest() {
            if (!this.beidiaoForm.name) {
                this.$message.warning("请输入姓名");
                return;
            }
            if (!this.beidiaoForm.idcard) {
                this.$message.warning("请输入身份证");
                return;
            }
            this.beidiaoLoading = true;
            this.beidiaoResult = null;
            workercrmapi.$axiosBeidiaoTest({
                name: this.beidiaoForm.name,
                idcard: this.beidiaoForm.idcard
            })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.beidiaoResult = {
                            success: true,
                            detail: this.formatBeidiaoResult(res.data.data)
                        };
                    } else {
                        this.beidiaoResult = {
                            success: false,
                            detail: res.data.errmsg || "背调验证失败"
                        };
                    }
                })
                .catch((res) => {
                    this.beidiaoResult = {
                        success: true,
                        detail: res.data.errmsg || "请求失败，请稍后重试"
                    };
                })
                .finally(() => {
                    this.beidiaoLoading = false;
                });
        },
        handleJoin(row) {
            //this.showBIVisible = true;
            console.info(row);
            let date = moment(new Date()).format("YYYY-MM-DD HH:ss:mm");
            //表示上线已完成到第几步：1信息完善 2背调 3签约 4正式上线
            var step = 1; //已上线
            if (row.state == 2) step = 4;
            else if (row.signContractState == 1) step = 4;
            else if (row.backInvestigate) step = 3;
            else if (row.ocrState == 1) step = 2;
            console.info("step" + step);
            this.$refs.addServantDiaRef.addServantData(
                row.id,
                row.cityId,
                row.buzLine,
                step,
                date,
                row
            );
        },
        handleDetail(row) {
            this.$router.push({
                path: "/workermanager/lifeManager/servantDetail",
                query: {
                    id: row.id,
                },
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            if (this.onlineTimeArr == null || this.onlineTimeArr == []) {
                this.listQuery.onlineTimeStart = "";
                this.listQuery.onlineTimeEnd = "";
            } else if (this.onlineTimeArr.length > 0) {
                this.listQuery.onlineTimeStart = this.onlineTimeArr[0] + " 00:00:00";
                this.listQuery.onlineTimeEnd = this.onlineTimeArr[1] + " 23:59:59";
            }

            if (this.lossTimeArr == null || this.lossTimeArr == []) {
                this.listQuery.leaveTimeStart = "";
                this.listQuery.leaveTimeEnd = "";
            } else if (this.lossTimeArr.length > 0) {
                this.listQuery.leaveTimeStart = this.lossTimeArr[0] + " 00:00:00";
                this.listQuery.leaveTimeEnd = this.lossTimeArr[1] + " 23:59:59";
            }
            workercrmapi.$axiosGetWorkerList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                    //console.info(this.listData);
                }
            });
        },
        getSupplierList() {
            //获取归属
            workercrmapi
                .$axiosGetSupplierList({ companyId: globalData.company.id })
                .then((res) => {
                    this.supplierList = res.data.data;
                });
        },
        getAllCity() {
            //城市下拉框
            wmsApi
                .$axiosgetallCity({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.cityList = res.data.data;
                    }
                });
        },
        getWorkerManager() {//获取所有商家运营
            workercrmapi.$axiosWorkerManagerAll().then(res => {
                this.workerManager = res.data.data;
            })
        },
        getWorkerPostLeader() {
            if (this.workerPostLeader.length > 0) return;
            workercrmapi.$axiosWorkerPostLeaderAll().then(res => {
                this.workerPostLeader = res.data.data;
            })
        },
        getSysUser() {
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
        downWorker() {
            // let ss = this.urlEncode(this.listQuery);
            // let params =
            //     "/workerSupplier/exportWorker?token=" +
            //     window.localStorage.getItem("token") +
            //     ss;
            // console.log(params);
            // window.open(url.salaryUrl + params);

            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            if (this.onlineTimeArr == null || this.onlineTimeArr == []) {
                this.listQuery.onlineTimeStart = "";
                this.listQuery.onlineTimeEnd = "";
            } else if (this.onlineTimeArr.length > 0) {
                this.listQuery.onlineTimeStart = this.onlineTimeArr[0] + " 00:00:00";
                this.listQuery.onlineTimeEnd = this.onlineTimeArr[1] + " 23:59:59";
            }

            if (this.lossTimeArr == null || this.lossTimeArr == []) {
                this.listQuery.leaveTimeStart = "";
                this.listQuery.leaveTimeEnd = "";
            } else if (this.lossTimeArr.length > 0) {
                this.listQuery.leaveTimeStart = this.lossTimeArr[0] + " 00:00:00";
                this.listQuery.leaveTimeEnd = this.lossTimeArr[1] + " 23:59:59";
            }

            workercrmapi.$ajaxWorkerExportWorker(this.listQuery)


        },
        downWorkerNewYear() {
            // let params =
            //     "/workerNewYear/newYearSurveyExport?token=" +
            //     window.localStorage.getItem("token");
            // window.open(url.salaryUrl + params);

            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            if (this.onlineTimeArr == null || this.onlineTimeArr == []) {
                this.listQuery.onlineTimeStart = "";
                this.listQuery.onlineTimeEnd = "";
            } else if (this.onlineTimeArr.length > 0) {
                this.listQuery.onlineTimeStart = this.onlineTimeArr[0] + " 00:00:00";
                this.listQuery.onlineTimeEnd = this.onlineTimeArr[1] + " 23:59:59";
            }

            if (this.lossTimeArr == null || this.lossTimeArr == []) {
                this.listQuery.leaveTimeStart = "";
                this.listQuery.leaveTimeEnd = "";
            } else if (this.lossTimeArr.length > 0) {
                this.listQuery.leaveTimeStart = this.lossTimeArr[0] + " 00:00:00";
                this.listQuery.leaveTimeEnd = this.lossTimeArr[1] + " 23:59:59";
            }

            workercrmapi.$ajaxWorkerExportWorkerNewYear(this.listQuery)
        },
        urlEncode(param, key, encode) {
            /*  @property {Object} param 将要转换为URL参数的字符串对象
                @property {String} key URL 参数字符串的前缀
                @property {Boolean} encode 是否进行URL编码，默认为true
            */
            if (param == null) return "";
            var paramStr = "";
            var t = typeof param;
            if (t == "string" || t == "number" || t == "boolean") {
                paramStr +=
                    "&" +
                    key +
                    "=" +
                    (encode == null || encode
                        ? encodeURIComponent(param)
                        : param);
            } else {
                for (var i in param) {
                    var k =
                        key == null
                            ? i
                            : key +
                            (param instanceof Array
                                ? "[" + i + "]"
                                : "." + i);
                    paramStr += this.urlEncode(param[i], k, encode);
                }
            }
            return paramStr;
        },
        goResign(workerNo) {
            this.$refs.resign.showDetail(workerNo);
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
